import type { AgriUnit } from '@/lib/api/agricultural-materials-api'
import { m } from '@/lib/paraglide/messages'

/**
 * Nhãn tiếng Việt của đơn vị vật tư nông nghiệp (mã canonical → nhãn).
 * Dùng chung cho form danh mục và ô định lượng của nhật ký chăm sóc: người nhập
 * phải thấy rõ đang nhập theo đơn vị nào (nhập 2 = 2 bao, không phải 2 kg).
 */
export function agriUnitLabel(unit?: string | null): string {
    switch (unit as AgriUnit) {
        case 'kg':
            return m.agri_unit_kg()
        case 'bag':
            return m.agri_unit_bag()
        case 'bottle':
            return m.agri_unit_bottle()
        case 'pack':
            return m.agri_unit_pack()
        default:
            return ''
    }
}
